export default __webpack_public_path__ + "static/media/shoes9.4b9f3a02.jpeg";